<template>
  <div class="nebTabs">
    <div class="nebTabs-tabList">
      <ul>
        <li class="nebTabs-tab"
          v-for="tab in tabs"
          :key="tab.name"
          @click="selectTab(tab)"
        >
          <span class="nebTabs-tabLabel"
            :class="{ 'active': tab.active }"
            :data-tab="tab.label"
          >
            {{ tab.label }}
          </span>
        </li>
      </ul>
    </div>

    <div class="nebTabs-content">
      <!-- Thisis the default slot for the `NebTab` components. -->
      <slot />
    </div>
  </div>
</template>

<script>
import { isNull } from 'lodash'

// Container for `NebTab` components. Renders a tab list and tab content.
// @group Layout
export default {
  name: 'nebTabs',

  props: {
    // The name of the tab you want to be active initially.
    initialActiveTab: {
      type: String,
      default: null
    }
  },

  data: () => ({
    tabs: []
  }),

  methods: {
    selectTab (tab) {
      tab.active = true

      this.tabs
        .filter(t => t.active && t.name !== tab.name)
        .forEach(t => { t.active = false })
    },
    getTab (name) {
      return this.tabs.filter(tab => tab.name === name)[0]
    }
  },

  mounted () {
    this.tabs = this.$children.filter(child => child.$options._componentTag === 'neb-tab')

    if (isNull(this.initialActiveTab)) {
      this.selectTab(this.tabs[0])
    } else {
      this.selectTab(this.getTab(this.initialActiveTab))
    }
  }
}
</script>

<style scoped lang="scss">
.nebTabs {
  &-tabList {
    ul {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      margin-top: 15px;
      list-style: none;
      padding-left: 0;
    }
  }

  &-tab {
    cursor: pointer;
    padding-right: 10px;

    &:not(:first-child) {
      padding-left: 10px;
    }

    &:not(:last-child) {
      border-right: solid 1px #cecece;
    }

    &.disabled {
      cursor: not-allowed;
    }
  }

  &-tabLabel {
    font-size: 16px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #5c5e62;

    &.active {
      font-weight: 700;
    }

    &.disabled {
      opacity: .25;
    }
  }

  &-content {
    box-sizing: border-box;
  }
}

.nebTabs-tabLabel::after {
  display: block;
  content: attr(data-tab);
  font-weight: bold;
  height: 1px;
  color: transparent;
  overflow: hidden;
  visibility: hidden;
}
</style>
